export default __webpack_public_path__ + "static/media/down-arrow.b1d6674c.svg";